import {post} from "../functions";

document.querySelectorAll('form.ajax-list-filter button.csv').forEach((button) => {
    button.addEventListener('click', () => {
        const form = button.form;
        exportCSV(form)
    });
});

async function exportCSV(form) {
    const apiUrl = form.dataset.api;
    const resp = await post('api/' + apiUrl + '?action=export', form);
    const blob = new Blob(['\ufeff' + resp], {type: 'text/csv;charset=utf-8;'});

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;

    a.download = `export_${new Date().toISOString().slice(0, 10)}.csv`;

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    a.remove();
}
